import { render, staticRenderFns } from "./DynamicFormModal.vue?vue&type=template&id=c8f2cdd6"
import script from "./DynamicFormModal.vue?vue&type=script&lang=js"
export * from "./DynamicFormModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormModal.vue?vue&type=style&index=0&id=c8f2cdd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports